import { damageLevelInfoGetRoundedStyle, getDamageLevelInfoMapper } from 'pages/NotifyEvent/constant_text'
import { IoCloseSharp } from 'react-icons/io5'
import { useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import { VariableReducer } from 'types/variable'

interface IDamageLevelInfoModal {
  close: () => void
  chooseDamageLevel: (id: string) => void
  chosenElementId: string
}
export default function DamageLevelInfoModal({ close, chooseDamageLevel, chosenElementId }: IDamageLevelInfoModal) {
  //redux state
  const variableSelector: VariableReducer = useSelector(
    (state: RootReducerState) => state.variableReducers
  )
  const dmgLevelList = variableSelector.variablesListDamageLevel
    ?.slice(1)
  const damageLevelInfoItems = getDamageLevelInfoMapper()


  return (
    <div data-testid="test-dmg-lvl-modal" className="md:p-8 text-left  md:max-w-[1022px] ">
      <div className='flex'>
        <p className="text-xl font-semibold text-yellow">Classificação do Incidente</p>
        <div
          className='ml-auto cursor-pointer'
          data-testid="test-close-dmg-lvl-modal"
          onClick={close}
        >
          <IoCloseSharp
            className="text-blueTheme h-8 w-8 p-1 cursor-pointer "
          />
        </div>
      </div>
      <p className="text-darkGray text-xs">
        Confira abaixo o que cada Grau de dano do incidente significa:
      </p>
      <div className='mt-4'>
        {damageLevelInfoItems.map((dmg, idx) => {
          const roundedStyle = damageLevelInfoGetRoundedStyle(idx, damageLevelInfoItems.length)
          const id = dmgLevelList?.find(l => l.label.trim() === dmg.serverLabel.trim())?.value
          const isSelected = id === chosenElementId
          return (
            <div
              key={idx} 
              onClick={() => {chooseDamageLevel(id) }}
              className={`hover:border-[#F0B323] border ${isSelected ? "bg-[#FFFCF3]  border-[#F0B323]" : "border-[#EBEFF5]"}  ${roundedStyle} flex md:flex-row flex-col justify-start px-2  md:px-6 py-2 md:items-center cursor-pointer`}>
              <div id={`${idx}`} className='md:w-[15%] mr-10'>
                <p className="text-blueTheme font-semibold text-sm md:text-base">
                  {dmg.level}
                </p>
              </div>
              <p className="text-darkGray md:text-sm w-[100%] text-[10px]">{dmg.info}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}
